import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { addBrandApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const addBrand = createAsyncThunk('addBrand', async (payload) => {
  return await addBrandApi(payload);
});

const addBrandSlice = createSlice({
  name: 'addBrand', // Unique Name
  initialState,
  reducers: {
    addBrandReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(addBrand.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(addBrand.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(addBrand.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { addBrandReset } = addBrandSlice.actions;

export default addBrandSlice.reducer;
